import { useSelector } from 'react-redux'
import i18n from '../../lang/idiomas'

const UnidadesEnCarrito = ({ codigo_articulo, variant = 'contador' }) => {
  const lineas = useSelector(state => state.pedidos.pedido?.lineas)

  const unidades = lineas
    ?.filter(linea => linea.articulo === codigo_articulo && linea.tipo_linea === 'P')
    .reduce((total, linea) => total + Number(linea.cantidad_pedida || 0), 0)

  // Si no hay unidades de este artículo en el carrito, no mostramos nada
  if (!unidades) return null

  if (variant === 'inline') {
    return (
      <span className='unidades-carrito-pill'>
        {i18n.t('articulos.uniencar', 'En carrito')}: {unidades}
      </span>
    )
  }

  // Contador superpuesto sobre la imagen

  return (
    <span
      className={
        variant === 'contador-ficha'
          ? 'unidades-carrito-contador en-ficha'
          : 'unidades-carrito-contador'
      }
      title={`${unidades} ${i18n.t('articulos.uniencar', 'en carrito')}`}>
      {unidades}
    </span>
  )
}

export default UnidadesEnCarrito
